/**
 * Parse an OIDC response fragment (or query string) into URLSearchParams,
 * tolerating a leading '#' or '?'. Used by the silent-SSO iframe callback
 * and the interactive Toegang login callback.
 */
export const parseUrlFragment = (fragment: string): URLSearchParams => {
  const cleaned =
    fragment.startsWith('#') || fragment.startsWith('?')
      ? fragment.slice(1)
      : fragment;
  return new URLSearchParams(cleaned);
};
